'use client';

import Link from 'next/link';
import React from 'react';

interface Props {
    error: Error & { digest?: string };
    reset: () => void;
}

export default function GlobalError() {
    return (
        <html dir="rtl" lang="fa">
            <body>
                <div className="not-found-page-container page-container pb-10">
                    <img src="/images/500.png" className="not-found-page-img" />
                    <div className="not-found-page-text-container">
                        <div className="not-found-page-title">متاسفیم که چیزی اینجا نیست!</div>
                        <div className="not-found-page-desc">
                            میتونی بری توی صفحه ی اصلی و چیزای جورواجور دیگه رو پیدا کنی
                        </div>
                    </div>
                    <Link href={'/'} className='flex w-11/12 mx-auto'>
                        <button className="not-found-page-btn">رفتن به صفحه اصلی</button>
                    </Link>
                </div>
            </body>
        </html>
    );
}
